import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEditBotCall.styl';


/**
 * @emits onClickChangePhone {} - ���� �� ������ �������� phone
 */
Vue.component('BXmakerAuthuserphoneEditBotCall',
    {
        props: [],
        data: function () {
            return {
                //��������� �������� ���� - ��������?
                // ��� ���������� �������� ����� ����� ����� - ��� �������������
                lastActionCheck: false,
            };
        },
        mounted() {
            this.$refs.refInputCode.focus();
        },
        computed: {
            noticeText() {
                let str = this.$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_BOT_CALL_NOTICE_START;
                str += this.$root.botCallLength;
                str += ' ';
                str += (this.$root.botCallLength <= 4
                        ? this.$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_BOT_CALL_NOTICE_NAME_4
                        : this.$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_BOT_CALL_NOTICE_NAME
                );
                str += this.$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_BOT_CALL_NOTICE_STOP;
                return str;
            }
        },
        methods: {
            onInputCode(value) {
                this.$root.setBotCallCode(value);
                if (this.$root.botCallLength === value.length) {
                    this.onClickCheck();
                }
            },
            onClickCheck() {
                this.lastActionCheck = true;
                this.$root.checkConfirmBotCall();
            },
            onClickChangePhone() {
                this.lastActionCheck = false;
                this.$root.resetMessage();
                this.$root.resetCaptcha();
                this.$root.hideConfirm();
            },
            onClickStart() {
                this.lastActionCheck = false;
                this.$root.setBotCallCode('');
                this.$root.startConfirmBotCall();

            },
            onCompleteCaptcha() {
                //��������� �������� ���������
                if (!this.lastActionCheck) {
                    this.onClickStart();
                    return;
                }

                //��������� �������� ���������
                if (this.$root.botCallLength !== this.$root.botCallCode.length) {
                    return;
                }

                this.onClickCheck();

            },
            onCompleteTimeout() {
                this.$root.setBotCallTimeout(0);
            }
        },
        template: `
            <div class="bxmaker-authuserphone-edit-botcall"  >
            
                <slot name="header">
                    <BXmakerAuthuserphoneHeader>
                        {{$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_BOT_CALL_TITLE}}
                    </BXmakerAuthuserphoneHeader>     
                </slot>
                
                <slot name="message">
                    <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error" />     
                </slot>                
                    
                <slot name="notice">
                    <div class="bxmaker-authuserphone-edit-botcall__notice">
                         {{noticeText}} 
                         
                         <span class="bxmaker-authuserphone-edit-botcall__phone">{{$root.formattedPhone}}</span>
                         
                         <BXmakerAuthuserphoneLink @onClick="onClickChangePhone">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_BOT_CALL_CHANGE_PHONE}}
                         </BXmakerAuthuserphoneLink>                     
                    </div>
                </slot>
                
                <slot name="code">
                    <BXmakerAuthuserphoneInputCode 
                        :value="$root.botCallCode" 
                        @onInput="onInputCode" 
                        @onEnter="onClickCheck" 
                        ref="refInputCode" 
                        :maxLength="$root.botCallLength"  
                        :loader="$root.botCallCheckLoader"
                    />
                </slot>
                               
                <slot name="captcha">
                    <BXmakerAuthuserphoneCaptcha 
                        :code="$root.captchaCode"
                        :src="$root.captchaSrc"
                        :length="$root.captchaLength"
                        :loader="$root.captchaLoader"
                        @onInput="$root.setCaptchaCode"
                        @onComplete="onCompleteCaptcha"
                        @onRefresh="$root.refreshCaptcha"
                   />  
                </slot>                                                        
                
                <slot name="timeout">
                    <BXmakerAuthuserphoneTimeout 
                    :timeout="$root.botCallTimeout"
                     v-if="$root.botCallTimeout"
                     @onComplete="onCompleteTimeout" >  
                        <template v-slot:before>
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_BOT_CALL_TIMEOUT_TITLE}} <br>
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_BOT_CALL_TIMEOUT_SUBTITLE}} 
                        </template>       
                     </BXmakerAuthuserphoneTimeout>  
                 </slot>             
                            
                <slot name="request">                
                    <div class="bxmaker-authuserphone-edit-botcall__send"  v-if="!$root.botCallTimeout" >
                        <BXmakerAuthuserphoneLink @onClick="onClickStart" v-if="!$root.botCallStartLoader">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_BOT_CALL_GET_NEW}}   
                         </BXmakerAuthuserphoneLink> 
                         <BXmakerAuthuserphoneLoader class="bxmaker-authuserphone-edit-botcall__send-loader" v-else />
                    </div>  
                </slot>              
                                
            </div>
        `,
    });